enum FeatureTypes {
  string = 'STRING',
  number = 'NUMBER',
  boolean = 'BOOLEAN',
  json = 'JSON',
}

type FeatureString = {
  type: FeatureTypes.string
  value: string
}

type FeatureNumber = {
  type: FeatureTypes.number
  value: number
}

type FeatureBoolean = {
  type: FeatureTypes.boolean
  value: boolean
}

type FeatureJson = {
  type: FeatureTypes.json
  value: string
}

export type FeatureKeys = keyof Features

type Feature = {
  key: FeatureKeys
} & (FeatureString | FeatureNumber | FeatureBoolean | FeatureJson)

export type FeatureHubResponse = {
  id: string
  features: Feature[]
}[]

export enum PromotionSupportStatus {
  disabled = 'disabled',
  enabled = 'enabled',
  featured = 'featured',
}

export type Features = {
  regular: PromotionSupportStatus
  combo: PromotionSupportStatus
  forThePriceOf: PromotionSupportStatus
  progressive: PromotionSupportStatus
  buyAndWin: PromotionSupportStatus
  campaign: PromotionSupportStatus
  skip_name_length_validation: boolean
  optin: boolean
  duplicate_modal: boolean
  budget: boolean
  benefit_modal: boolean
  create_promotion_drawer: boolean
  template: boolean
}

export const FALLBACK_FEATURES: Features = {
  regular: PromotionSupportStatus.disabled,
  combo: PromotionSupportStatus.enabled,
  forThePriceOf: PromotionSupportStatus.enabled,
  progressive: PromotionSupportStatus.enabled,
  buyAndWin: PromotionSupportStatus.enabled,
  campaign: PromotionSupportStatus.disabled,
  skip_name_length_validation: true,
  optin: false,
  duplicate_modal: true,
  budget: false,
  benefit_modal: false,
  create_promotion_drawer: false,
  template: false,
}
